import { createAction, props } from '@ngrx/store';
import { IVehiclesState } from './vehicles.state';

export const initVehiclesAction = createAction('[vehicle Page] vehicle page');

export const setVehiclesAction = createAction(
  '[vehicle Page] set data',
  props<IVehiclesState>()
);
